import { render } from "./OccupationalSafetyExpertsCPage.vue?vue&type=template&id=57aa87ee&scoped=true"
import script from "./OccupationalSafetyExpertsCPage.vue?vue&type=script&lang=js"
export * from "./OccupationalSafetyExpertsCPage.vue?vue&type=script&lang=js"

import "./OccupationalSafetyExpertsCPage.vue?vue&type=style&index=0&id=57aa87ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57aa87ee"]])

export default __exports__